import { render } from "./Check.vue?vue&type=template&id=c189fa6e&ts=true"
import script from "./Check.vue?vue&type=script&lang=ts"
export * from "./Check.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__